
$(document).on "click", ".response_condition_header", (event) ->
  event.preventDefault()

  selected_header = event.currentTarget
  selected_condition = App.Helpers.Elements.closest(selected_header, ".response_condition")

  App.Elements.ResponseQuery.Query.toggle_condition_drawer(selected_condition)
